import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_set_targets_for_social_and_labor_performance_addres'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_set_targets_for_social_and_labor_performance_addres',
  name: 'Has the facility set targets for social and labor performance addressing the following points?',
  description:
    'The intent of this question is to understand if the facility has set targets or KPIs (key performance indicators) for social and labor practices. \r\r\n\r\r\n"Targets" refer to indicators of what success looks like. What milestones should be achieved to meet targets etc. \r\r\n\r\r\nTargets can be related to more absolute numbers (i.e. 0 cases of "child labor", 50% reduction in OT hours) or related to number of trainings, processes, programs developed to support good social performance.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'CHILD_LABOR_AND_OR_YOUNG_WORKERS',
      text: 'Child labor and/or young workers',
      externalIds: [
        {
          id: 'ms-3-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-1f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'PROHIBITION_OF_FORCED_LABOR',
      text: 'Prohibition of forced labor',
      externalIds: [
        {
          id: 'ms-3-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-2f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ANTI_HARASSMENT_AND_ABUSE',
      text: 'Anti-harassment and abuse',
      externalIds: [
        {
          id: 'ms-3-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-3f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ANTI_DISCRIMINATION',
      text: 'Anti-discrimination',
      externalIds: [
        {
          id: 'ms-3-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-4f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WORKING_HOURS',
      text: 'Working hours',
      externalIds: [
        {
          id: 'ms-3-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-5f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WAGES_AND_BENEFITS',
      text: 'Wages and benefits',
      externalIds: [
        {
          id: 'ms-3-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-6f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DISCIPLINE',
      text: 'Discipline',
      externalIds: [
        {
          id: 'ms-3-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-7f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
      text: 'Freedom of association and collective bargaining',
      externalIds: [
        {
          id: 'ms-3-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-8f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WORKER_FEEDBACK',
      text: 'Worker Feedback',
      externalIds: [
        {
          id: 'ms-3-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-9f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'GRIEVANCE_SYSTEMS',
      text: 'Grievance systems',
      externalIds: [
        {
          id: 'ms-3-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-10f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HEALTH_AND_SAFETY',
      text: 'Health and safety',
      externalIds: [
        {
          id: 'ms-3-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-11f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FOREIGN_MIGRANT_WORKERS',
      text: 'Foreign migrant workers',
      externalIds: [
        {
          id: 'ms-pla-59x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-pla-60f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DOMESTIC_MIGRANT_WORKERS',
      text: 'Domestic migrant workers',
      externalIds: [
        {
          id: 'ms-pla-61x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-pla-62f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HOMEWORKERS',
      text: 'Homeworkers',
      externalIds: [
        {
          id: 'ms-3-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-14f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'GENDER_EQUALITY_AND_WOMEN_S_RIGHTS_IN_THE_WORKPLACE',
      text: "Gender equality and women's rights in the workplace",
      externalIds: [
        {
          id: 'ms-pla-63x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-pla-64f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'BRIBERY_AND_ANTI_CORRUPTION',
      text: 'Bribery and anti-corruption',
      externalIds: [
        {
          id: 'ms-3-15x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-15f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SUPPLIERS_SUBCONTRACTORS',
      text: 'Suppliers/subcontractors',
      externalIds: [
        {
          id: 'ms-3-16x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please briefly describe any associated targets/KPIs:',
        externalIds: [
          {
            id: 'ms-3-16f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-3-17x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-3-17f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'CHILD_LABOR_AND_OR_YOUNG_WORKERS',
                'PROHIBITION_OF_FORCED_LABOR',
                'ANTI_HARASSMENT_AND_ABUSE',
                'ANTI_DISCRIMINATION',
                'WORKING_HOURS',
                'WAGES_AND_BENEFITS',
                'DISCIPLINE',
                'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
                'WORKER_FEEDBACK',
                'GRIEVANCE_SYSTEMS',
                'HEALTH_AND_SAFETY',
                'FOREIGN_MIGRANT_WORKERS',
                'DOMESTIC_MIGRANT_WORKERS',
                'HOMEWORKERS',
                'GENDER_EQUALITY_AND_WOMEN_S_RIGHTS_IN_THE_WORKPLACE',
                'BRIBERY_AND_ANTI_CORRUPTION',
                'SUPPLIERS_SUBCONTRACTORS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-58',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 20670,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
